import { render } from "./MenuInferior.vue?vue&type=template&id=4eab7901"
import script from "./MenuInferior.vue?vue&type=script&lang=js"
export * from "./MenuInferior.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__